import {
  IssueReportedType,
  JobBudgetOptions,
  PropertyKeyCollectType,
  StrataPropertyKeyCollectType,
} from './job-post.enums';

export const IssueReportedTypeLabel = new Map<IssueReportedType, string>([
  [IssueReportedType.FromEmail, 'Email from tenant or owner'],
  [IssueReportedType.FromCall, 'Call from tenant or owner'],
  [IssueReportedType.InvoiceOnly, 'invoice only'],
]);

export const PropertyKeyCollectTypeLabel = new Map<
  PropertyKeyCollectType,
  string
>([
  [
    PropertyKeyCollectType.ContactTenant,
    'Contact tenant to arrange access and time',
  ],
  [
    PropertyKeyCollectType.CollectFromOfficeAndEnter,
    'Please collect keys from the office to enter the property',
  ],
  [
    PropertyKeyCollectType.CollectFromOfficeAndInformTenant,
    'Collect the key from the office, inform the tenant on date & time',
  ],
  [
    PropertyKeyCollectType.Custom,
    'Custom',
  ]
]);

export const StrataPropertyKeyCollectTypeLabel = new Map<
StrataPropertyKeyCollectType,
  string
>([
  [
    StrataPropertyKeyCollectType.ContactTenant,
    'Contact tenant to arrange access and time',
  ],
  [
    StrataPropertyKeyCollectType.CollectFromOfficeAndEnter,
    'Please collect keys from the office to enter the property',
  ],
  [
    StrataPropertyKeyCollectType.CollectFromOfficeAndInformTenant,
    'Collect the key from the office, inform the tenant on date & time',
  ],
  [
    StrataPropertyKeyCollectType.AccessThroughSafeKey,
    'Access through key safe',
  ],
]);

export const JobBudgetOptionsLabel = new Map<JobBudgetOptions, string>([
  [JobBudgetOptions.CustomizedUnder, 'Under'],
  [JobBudgetOptions.UnSure, 'Unsure'],
  [JobBudgetOptions.Under500, 'Under $500'],
  [JobBudgetOptions.Between500N1000, '$500 - $1000'],
  [JobBudgetOptions.Between1000N2000, '$1000 - $2000'],
  [JobBudgetOptions.Between2000N5000, '$2000 - $5000'],
  [JobBudgetOptions.Over5000, '$5000+'],
  [JobBudgetOptions.Estimate, 'Estimate'],
  [JobBudgetOptions.Custom, 'Custom'],
]);
